
import Button from '../../../components/base/Button';

export default function CTASection() {
  return (
    <section className="py-16 bg-blue-600">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
          理想の住まい探しを始めませんか？
        </h2>
        <p className="text-xl text-blue-100 mb-8 max-w-3xl mx-auto">
          経験豊富なスタッフが、お客様のご希望に合った最適な物件をご提案いたします。
          まずはお気軽にご相談ください。
        </p>
        
        <div className="flex justify-center">
          <Button size="lg" variant="outline" className="border-white text-white hover:bg-white hover:text-blue-600">
            <i className="ri-mail-line mr-2"></i>
            メールで相談する
          </Button>
        </div>
        
        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          <div className="text-center">
            <div className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center mx-auto mb-3">
              <i className="ri-time-line text-white text-xl"></i>
            </div>
            <h3 className="text-white font-semibold mb-1">営業時間</h3>
            <p className="text-blue-100 text-sm">平日 9:00-19:00<br />土日祝 10:00-18:00</p>
          </div>
          
          <div className="text-center">
            <div className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center mx-auto mb-3">
              <i className="ri-phone-line text-white text-xl"></i>
            </div>
            <h3 className="text-white font-semibold mb-1">お電話</h3>
            <p className="text-blue-100 text-sm">03-1234-5678<br />通話料無料</p>
          </div>
          
          <div className="text-center">
            <div className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center mx-auto mb-3">
              <i className="ri-calculator-line text-white text-xl"></i>
            </div>
            <h3 className="text-white font-semibold mb-1">無料査定</h3>
            <p className="text-blue-100 text-sm">売却をお考えの方<br />査定は無料です</p>
          </div>
        </div>
      </div>
    </section>
  );
}
